<template>
  <g>
    <path
      d="M4 4.92875C4 3.86363 4.87915 3.00018 5.96364 3.00018H16.7636C17.8481 3.00018 18.7273 3.86363 18.7273 4.92875V19.0716C18.7273 20.1367 17.8481 21.0002 16.7636 21.0002H9.33779C8.96127 21.0002 8.60299 20.841 8.35445 20.5632L4.32575 16.0607C4.11579 15.826 4 15.5243 4 15.212V4.92875Z"
      fill="white"
    />
    <path
      d="M4 4.92875C4 3.86363 4.87915 3.00018 5.96364 3.00018H16.7636C17.8481 3.00018 18.7273 3.86363 18.7273 4.92875V19.0716C18.7273 20.1367 17.8481 21.0002 16.7636 21.0002H9.33779C8.96127 21.0002 8.60299 20.841 8.35445 20.5632L4.32575 16.0607C4.11579 15.826 4 15.5243 4 15.212V4.92875Z"
      fill="url(#paint0_linear_939_1134)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 4.92875C3.5 3.57904 4.61154 2.50018 5.96364 2.50018H16.7636C18.1157 2.50018 19.2273 3.57904 19.2273 4.92875V19.0716C19.2273 20.4213 18.1157 21.5002 16.7636 21.5002H9.33779C8.82068 21.5002 8.32632 21.2816 7.98183 20.8966L3.95313 16.3941C3.66187 16.0686 3.5 15.6484 3.5 15.212V4.92875ZM5.96364 3.50018C5.14676 3.50018 4.5 4.14823 4.5 4.92875V15.212C4.5 15.4002 4.56972 15.5835 4.69836 15.7273L8.72706 20.2298C8.87966 20.4003 9.10187 20.5002 9.33779 20.5002H16.7636C17.5805 20.5002 18.2273 19.8521 18.2273 19.0716V4.92875C18.2273 4.14823 17.5805 3.50018 16.7636 3.50018H5.96364Z"
      fill="#3E7DC0"
    />
    <path
      d="M6.29092 8.30374C6.29092 8.03746 6.51071 7.82159 6.78183 7.82159H14.3091C14.5802 7.82159 14.8 8.03746 14.8 8.30374C14.8 8.57002 14.5802 8.78588 14.3091 8.78588H6.78183C6.51071 8.78588 6.29092 8.57002 6.29092 8.30374Z"
      fill="#3E7DC0"
    />
    <path
      d="M6.29092 10.8751C6.29092 10.6089 6.51071 10.393 6.78183 10.393H11.3637C11.6348 10.393 11.8546 10.6089 11.8546 10.8751C11.8546 11.1414 11.6348 11.3573 11.3637 11.3573H6.78183C6.51071 11.3573 6.29092 11.1414 6.29092 10.8751Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.6 16.1966H4V15.1966H7.6C8.5906 15.1966 9.40909 15.9876 9.40909 16.9823V21.0002H8.40909V16.9823C8.40909 16.5568 8.05538 16.1966 7.6 16.1966Z"
      fill="#3E7DC0"
    />
    <path
      d="M11.886 16.0533C11.886 14.9561 12.7916 14.0667 13.9088 14.0667H19.9772C21.0944 14.0667 22.0001 14.9561 22.0001 16.0533V22.0134C22.0001 23.1107 21.0944 24.0001 19.9772 24.0001H13.9088C12.7916 24.0001 11.886 23.1107 11.886 22.0134V16.0533Z"
      fill="#3E7DC0"
    />
    <path
      d="M16.6083 17.5681L16.8481 15.9258C16.8881 15.6519 16.5108 15.5287 16.3758 15.7716L14.5693 19.0245C14.3855 19.3555 14.6294 19.759 15.0133 19.759H16.8041C17.1023 19.759 17.3357 20.011 17.3076 20.3025L17.1644 21.7887C17.1384 22.0582 17.5077 22.1682 17.6386 21.9301L19.3215 18.8679C19.5034 18.5369 19.2594 18.1353 18.8765 18.1353H17.1089C16.8011 18.1353 16.5647 17.8674 16.6083 17.5681Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_939_1134"
        x1="11.3636"
        y1="1.81986"
        x2="11.3636"
        y2="17.6067"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
